import "./Hero.css";

const Hero = ({ name, children }) => {
    const heroClasses = `hero bg-fixed ${name}`;
    const contentClasses = `hero-content ${name}`;

    return (
        <section className={heroClasses}>
            <div className={contentClasses}>
                <div className="container">{children}</div>
            </div>
        </section>
    );
};

export default Hero;
